webpackJsonp([519],{

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2082:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1128),
  /* template */
  __webpack_require__(2935),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/next_zh-CN-279.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] next_zh-CN-279.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-88991626", Component.options)
  } else {
    hotAPI.reload("data-v-88991626", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2935:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加属性 prop:content")])]), _vm._v(" "), _c('h2', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 prop:is-loading 显示加载图标，适用于异步加载数据的场景")])]), _vm._v(" "), _c('h2', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 在 nextTick 回调渲染 picker 避免赋值报错 #1180")])]), _vm._v(" "), _c('h2', [_vm._v("Scroller")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 resize 事件没有移除导致切换页面报错 #1183")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复滚动情况下跳转页面报错 #1187")])]), _vm._v(" "), _c('h2', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复disabled时不能上下滚动问题")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复disabled时，安卓手机上不能触发点击事件的问题")])]), _vm._v(" "), _c('h2', [_vm._v("XIcon")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持传任意属性 #1147")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-88991626", module.exports)
  }
}

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2082);

/***/ })

});


// WEBPACK FOOTER //
// 519.fdc80525.js